import { FormTaxRate } from "../../../TaxWithholdings/components/FormTaxRate";
import { useOnboardingContext } from "../../Context";
import { TaxWithholdingsContext } from "./types";
import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

/**
 * v1 split this step over two sub-routes — `/estimate-tax-rate` wrote the tax
 * profile, `/tax-rate` read it back and set the rate. v3 persists no tax
 * profile, so there was nothing for the first screen to save; both now live on
 * one form and the step renders it directly.
 */
export const CalculateTaxRate: React.FC<FlowStep> = props => {
  const [_, setContext] = useOnboardingContext<TaxWithholdingsContext>();

  return (
    <FormTaxRate
      onBack={props.onBack}
      onNext={props.onNext}
      onSkip={() => {
        setContext(prev => ({
          ...prev,
          taxWithholdingsSkipped: true
        }));
        props.onSkip?.();
      }}
    />
  );
};
